<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" style="height: 100vh">
  <h1>Health check</h1>

  <div class="hc-status" [ngClass]="{ 'success' : upAndRunning, 'fail' : upAndRunning === false }"></div>
</div>

